/**
 * JeriCommerce Pass API · staging
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export const ApiKeyPermissionEnum = {
    CustomersRead: 'customers:read',
    CustomerTokensWrite: 'customer-tokens:write',
    BalanceWrite: 'balance:write',
    CouponsWrite: 'coupons:write',
    CampaignsWrite: 'campaigns:write',
    PushWrite: 'push:write',
    EarningFlowsWrite: 'earning-flows:write',
    SubscriptionsWrite: 'subscriptions:write',
    IntegrationApiWrite: 'integration-api:write',
    McpRead: 'mcp:read',
    McpWrite: 'mcp:write',
    VtapWrite: 'vtap:write'
} as const;
export type ApiKeyPermissionEnum = typeof ApiKeyPermissionEnum[keyof typeof ApiKeyPermissionEnum];

